import { Shield, User } from 'lucide-react';

const AuditLogs = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">System Audit Logs</h1>
      <p className="text-sm text-gray-500 mt-1">
        Immutable trail of system activities · PRD: LOG (Section 7.11)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Activity Log</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 uppercase text-xs border-b border-gray-700/50">
              <th className="text-left py-3 pr-4 font-medium">Timestamp</th>
              <th className="text-left py-3 pr-4 font-medium">Actor</th>
              <th className="text-left py-3 pr-4 font-medium">Action</th>
              <th className="text-left py-3 pr-4 font-medium">Target</th>
              <th className="text-left py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody className="text-gray-400">
            {[
              { ts: '2026-05-12 14:32:07', actor: 'admin@sentinel.io', action: 'LOGIN', target: 'Web Console', status: 'Success' },
              { ts: '2026-05-12 14:28:55', actor: 'analyst@sentinel.io', action: 'EXPORT', target: 'Threat Report #124', status: 'Success' },
              { ts: '2026-05-12 13:15:42', actor: 'system', action: 'ROTATE', target: 'API Key sk_sentinel_****', status: 'Success' },
              { ts: '2026-05-12 12:01:18', actor: 'admin@sentinel.io', action: 'INVITE', target: 'operator@corp.io', status: 'Success' },
              { ts: '2026-05-12 11:45:03', actor: 'operator@corp.io', action: 'ACCEPT', target: 'Org Invitation', status: 'Success' },
              { ts: '2026-05-12 10:22:59', actor: '192.168.1.105', action: 'LOGIN', target: 'Web Console', status: 'Failed' },
              { ts: '2026-05-12 09:10:44', actor: 'admin@sentinel.io', action: 'UPDATE', target: 'Security Policy', status: 'Success' },
              { ts: '2026-05-11 23:55:21', actor: 'system', action: 'BACKUP', target: 'Database Snapshot', status: 'Success' },
            ].map((entry, i) => (
              <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                <td className="py-3 pr-4 font-mono text-xs text-gray-500">{entry.ts}</td>
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <User className="w-3.5 h-3.5 text-gray-600" />
                    <span>{entry.actor}</span>
                  </div>
                </td>
                <td className="py-3 pr-4">
                  <span className="px-2 py-0.5 rounded text-xs font-mono font-medium bg-gray-800 text-gray-300">
                    {entry.action}
                  </span>
                </td>
                <td className="py-3 pr-4">{entry.target}</td>
                <td className="py-3">
                  <span className={`inline-flex items-center gap-1 text-xs font-medium ${
                    entry.status === 'Success' ? 'text-emerald-400' : 'text-red-400'
                  }`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${
                      entry.status === 'Success' ? 'bg-emerald-400' : 'bg-red-400'
                    }`} />
                    {entry.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default AuditLogs;
